import paths from 'routing/routes/_paths';

import Users from 'views/users';

const routes = [
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.users,
    component: Users,
    documentTitle: 'Users'
  }
];

export default routes;
